// extracted by mini-css-extract-plugin
export var icon = "_61-1";
export var subtext = "_61-0";